import { MenuItem, Box } from '@mui/material';
import { CustomButton, CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common/components';

const InvoiceQueryFilters = ({ salePoints, salePoint, setSalePoint, voucherNumber, setVoucherNumber, onSearch, isLoading }) => (
  <HeaderFilterBox variant="twoRows">
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1, width: '100%' }}>
      <CustomSelect
        label="Punto de Venta"
        labelId="sale-point-label"
        id="sale-point-select"
        name="salePoint"
        value={salePoint}
        onChange={e => setSalePoint(e.target.value)}
        displayEmpty
        disabled={isLoading}
        sx={{ width: '150px', mb: { xs: 1, md: 0 }, mt: 0 }}
      >
        <MenuItem sx={{ display: 'none' }} value="">Seleccionar</MenuItem>
        {salePoints.map(sp => (
          <MenuItem key={sp.uuid} value={sp.number}>{sp.number}</MenuItem>
        ))}
      </CustomSelect>
      <CustomTextField
        label="N° Comprobante"
        type="number"
        value={voucherNumber}
          onChange={e => {
            const val = e.target.value;
            if (/^\d{0,8}$/.test(val)) {
              setVoucherNumber(val);
            }
          }}
        disabled={isLoading}
        sx={{ width: 340, mt: 0 }}
          inputProps={{ maxLength: 8, min: 0, max: 99999999, step: 1 }}
      />
      <CustomButton
        variant="base"
        color="primary"
        onClick={onSearch}
        disabled={isLoading || !salePoint || !voucherNumber}
      >
        Buscar
      </CustomButton>
    </Box>
  </HeaderFilterBox>
);

export default InvoiceQueryFilters;
